import { schema } from 'components/roles/role-form/role-form.consts';
import type { RolesApi } from '@env0/role-service/api';
import type { DeepPartial, UnpackNestedValue } from 'react-hook-form';
import type { RoleUpdate, UIRole } from 'stores/roles-store/use-roles';

export const formatPayload = (
  { name, permissions }: RoleUpdate,
  organizationId: string
): RolesApi.Create.Request.Body => ({
  name,
  organizationId,
  permissions: (Object.keys(permissions) as Array<keyof typeof permissions>).filter(key => permissions[key])
});

export const formatResponse = (role: RolesApi.Role): UIRole => {
  const permissions = role.permissions.reduce((prev, curr) => {
    prev[curr] = true;
    return prev;
  }, {} as Record<RolesApi.RBACPermission, boolean>);

  const defaultPermissions = schema.getDefault().permissions as UnpackNestedValue<DeepPartial<UIRole>>;

  return {
    id: role.id!,
    name: role.name,
    permissions: {
      ...defaultPermissions,
      ...permissions
    }
  };
};
